<template>
    <div class="members-table">
        <ve-table
            :columns="getColumns()"
            :table-data="members"
            :row-style-option="rowStyleOption"
            :cell-style-option="cellStyleOption"
            :border-x="true"
            :border-y="true"
            row-key-field-name="_id"
            id="ticimax-members-table"
            :fixed-header="true"
            style="word-break: break-word"
            :style="{
                width: getMaxWidth() + 'px',
            }"
            :scroll-width="getMaxWidth() + 3500"
            :clipboard-option="clipboardOption"
        />
    </div>
</template>

<script>
import Vue from "vue";
import MoneyFormatter from "../../../../../components/MoneyFormatter.vue";
import moment from "moment";
import _ from "lodash";

export default Vue.extend({
    name: "MembersTable",
    props: {
        members: {
            type: Array,
            required: true,
        },
        value: {
            type: Object,
            required: true,
            default: () => ({
                sort: {
                    field: "lastOrderDate",
                    direction: -1,
                },
                filters: {},
                cursor: {
                    page: 1,
                    perPage: 50,
                },
            }),
        },
        loading: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            model: _.cloneDeep(this.value),
            loadingInstance: null,
            clipboardOption: {
                copy: true,
                paste: false,
                cut: false,
                delete: false,
            },
            rowStyleOption: {
                stripe: true,
            },
            cellStyleOption: {
                bodyCellClass: function ({ row, column, rowIndex }) {
                    const classNames = [column.key];
                    if (column.key === "segment") {
                        classNames.push(row.segment);
                    } else if (column.key === "vip") {
                        if (row.vip) {
                            classNames.push("vip-active");
                        }
                    }
                    return classNames.join(" ");
                },
            },
        };
    },
    methods: {
        getMaxWidth() {
            return /*this.fullScreen ? window.innerWidth :*/ window.innerWidth - 710;
        },
        getColumns() {
            console.log("getColumns", this.users);
            return [
                // {
                //     field: "",
                //     key: "a",
                //     type: "expand",
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "email",
                    key: "email",
                    title: this.$t("chatbotv2.attr.email"),
                    align: "left",
                    fixed: "left",
                    width: 200,
                },
                {
                    field: "fullname",
                    key: "fullname",
                    title: this.$t("chatbotv2.attr.name"),
                    align: "left",
                    width: 150,
                },
                {
                    field: "phone",
                    key: "phone",
                    title: this.$t("chatbotv2.attr.phone"),
                    align: "left",
                    width: 150,
                },
                {
                    field: "province",
                    key: "province",
                    title: this.$t("chatbotv2.city"),
                    align: "left",
                    width: 100,
                },
                {
                    field: "county",
                    key: "county",
                    title: this.$t("ticimax.attributes.county"),
                    align: "left",
                    width: 100,
                },
                {
                    field: "totalOrderCount",
                    key: "totalOrderCount",
                    title: this.$t("ticimax.attributes.totalOrderCount"),
                    align: "left",
                    width: 100,
                },
                {
                    field: "totalOrderAmount",
                    key: "totalOrderAmount",
                    title: this.$t("ticimax.attributes.totalOrderAmount"),
                    align: "left",
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(MoneyFormatter, {
                            props: {
                                price: row.totalOrderAmount,
                            },
                        });
                    },
                },
                {
                    field: "minOrderAmount",
                    key: "minOrderAmount",
                    title: this.$t("ticimax.attributes.minOrderAmount"),
                    align: "left",
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(MoneyFormatter, {
                            props: {
                                price: row.minOrderAmount,
                            },
                        });
                    },
                },
                {
                    field: "maxOrderAmount",
                    key: "maxOrderAmount",
                    title: this.$t("ticimax.attributes.maxOrderAmount"),
                    align: "left",
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(MoneyFormatter, {
                            props: {
                                price: row.maxOrderAmount,
                            },
                        });
                    },
                },
                {
                    field: "firstOrderDate",
                    key: "firstOrderDate",
                    title: this.$t("ticimax.attributes.firstOrderDate"),
                    align: "left",
                    width: 175,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{moment(row.firstOrderDate).format("YYYY-MM-DD HH:mm:ss")}</span>;
                    },
                },
                {
                    field: "lastOrderDate",
                    key: "lastOrderDate",
                    title: this.$t("ticimax.attributes.lastOrderDate"),
                    align: "left",
                    width: 175,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{moment(row.lastOrderDate).format("YYYY-MM-DD HH:mm:ss")}</span>;
                    },
                },
                {
                    field: "firstPaymentType",
                    key: "firstPaymentType",
                    title: this.$t("ticimax.attributes.firstPaymentType"),
                    width: 120,
                    align: "left",
                },
                {
                    field: "lastPaymentType",
                    key: "lastPaymentType",
                    title: this.$t("ticimax.attributes.lastPaymentType"),
                    width: 120,
                    align: "left",
                },
                {
                    field: "firstSource",
                    key: "firstSource",
                    title: this.$t("ticimax.attributes.firstSource"),
                    width: 100,
                    align: "left",
                },
                {
                    field: "lastSource",
                    key: "lastSource",
                    title: this.$t("ticimax.attributes.lastSource"),
                    width: 100,
                    align: "left",
                },
                {
                    field: "usedCouponCount",
                    key: "usedCouponCount",
                    title: this.$t("ticimax.attributes.usedCouponCount"),
                    align: "left",
                    width: 120,
                },
                {
                    field: "usedCouponAmount",
                    key: "usedCouponAmount",
                    title: this.$t("ticimax.attributes.usedCouponAmount"),
                    align: "left",
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(MoneyFormatter, {
                            props: {
                                price: row.usedCouponAmount,
                            },
                        });
                    },
                },
                {
                    field: "couponUsingPercentage",
                    key: "couponUsingPercentage",
                    title: this.$t("ticimax.attributes.couponPercent"),
                    align: "left",
                    width: 100,
                },
                {
                    field: "vip",
                    key: "vip",
                    title: "VIP",
                    align: "left",
                    width: 100,
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.vip ? <span>VIP</span> : <span>-</span>;
                    },
                },
                {
                    field: "isCouponUser",
                    key: "isCouponUser",
                    title: this.$t("ticimax.attributes.isCouponUser"),
                    align: "left",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.isCouponUser ? <span class="coupon">Kuponcu</span> : <span>-</span>;
                    },
                },
                {
                    field: "tookDayFromLastOrder",
                    key: "tookDayFromLastOrder",
                    title: this.$t("ticimax.attributes.tookDayFromLastOrder"),
                    width: 100,
                    align: "left",
                },
                {
                    field: "segment",
                    key: "segment",
                    title: "Segment",
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span class="coupon">{row.segment}</span>;
                    },
                    fixed: "right",
                    width: 100,
                },
            ];
        },
    },
    mounted() {
        this.loadingInstance = this.$veLoading({
            target: document.querySelector("#ticimax-members-table"),
            name: "wave",
        });
        if (this.loading) {
            this.loadingInstance.show();
        }
    },
    watch: {
        loading: function (val) {
            if (val) {
                this.loadingInstance.show();
            } else {
                this.loadingInstance.close();
            }
        },
        value: {
            handler: function (val) {
                this.model = _.cloneDeep(val);
            },
            deep: true,
        },
        clone: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.value);
                    if (isChanged) {
                        this.$emit("input", val);
                    }
                }
            },
            deep: true,
        },
    },
});
</script>

<style lang="scss">
#ticimax-members-table {
    .ve-table-body-td {
        &.segment {
            padding: 0px;
            font-weight: 700;
            font-size: 14px;
            text-transform: uppercase;

            span {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            &.active-30 {
                background-color: #67c23a;

                color: white;
            }

            &.active-60 {
                background-color: #e6a23c;
                color: white;
            }

            &.active-90 {
                background-color: #f56c6c;
                color: white;
            }

            &.lost {
                background-color: #909399;
                color: white;
            }
        }

        &.vip {
            padding: 0px;

            font-weight: 700;
            font-size: 14px;
            text-transform: uppercase;

            span {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            &.vip-active {
                background-image: linear-gradient(
                    to right,
                    #d16ba5,
                    #c777b9,
                    #ba83ca,
                    #aa8fd8,
                    #9a9ae1,
                    #8aa7ec,
                    #79b3f4,
                    #69bff8,
                    #52cffe,
                    #41dfff,
                    #46eefa,
                    #5ffbf1
                );
                color: white;
            }
        }
    }
}
</style>
